<template>
  <button id="close" role="button" aria-label="close" v-on="$listeners">
    <i class="af-icons af-icons-cross"></i>
  </button>
</template>

<script>
export default {};
</script>
